module.exports = __webpack_public_path__ + "dimer/static/img/17.75ced35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/17.jpg
// module id = 5m14
// module chunks = 0